
import './skeleton.css';

const Skeleton = ({ extraClass }) => {
    return (
        <div className="skeleton-wrapper">
            <div className="skeleton">
                <div className={`rounded-lg bg-slate-300  ${extraClass ? extraClass : ""} `}> </div>
            </div>
            <div className="shimmer-wrapper">
                <div className="shimmer"></div>
            </div>
        </div>
    )
}

export default Skeleton;